import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import { useCartSync } from "@/hooks/useCartSync";
import type { CartSync } from "@/hooks/useCartSync";
import { useOrderRestore } from "@/hooks/useOrderRestore";

/**
 * Единственная точка синхронизации корзины на всё приложение.
 *
 * Провайдер, а не вызов useCartSync по месту: PreorderForm рендерится
 * ModalWrapper'ом и приходится PreorderPage соседом, а не потомком
 * (router/index.tsx), поэтому flush кнопке пропсом не передать. Второй же
 * вызов useCartSync завёл бы второй дебаунс — то самое двойное создание
 * черновика.
 */
const CartSyncContext = createContext<CartSync | null>(null);

export const CartSyncProvider = ({ children }: { children: ReactNode }) => {
  const sync = useCartSync();
  // Здесь же — единственная точка наполнения корзины с сервера: второй
  // экземпляр useOrderRestore применял бы ответ повторно.
  useOrderRestore();
  return (
    <CartSyncContext.Provider value={sync}>{children}</CartSyncContext.Provider>
  );
};

/** Флаш незавершённого дебаунса — кнопке предзаказа. */
export function useCartSyncContext(): CartSync {
  const context = useContext(CartSyncContext);
  if (!context) {
    throw new Error("useCartSyncContext вызван вне CartSyncProvider");
  }
  return context;
}
